import HolidaysDatePickerController from './HolidaysDatePickerController';

export default HolidaysDatePickerController;
